import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {ReportComponentSummaryModel} from '../../entity/reportComponentSummary.model';

@Component({
  selector: 'app-report-component-select-filter',
  templateUrl: './report-component-select-filter.component.html',
})
export class ReportComponentSelectFilterComponent {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() findAllService: AbstractFindAllService<any, ReportComponentSummaryModel>;

  constructor() {
  }

  filter = (criteria: string, entity: ReportComponentSummaryModel) => {
    return (entity.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

  resolveSelectFilterElement = (entity: ReportComponentSummaryModel): SelectFilterElement<number, ReportComponentSummaryModel> => {
    return new SelectFilterElement(entity.id, entity.id, entity);
  }

}
